module.exports = __webpack_public_path__ + "static/media/MainPage_5.870a8988.png";